var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "welcome" }, [_vm._v("修 改 密 码")]),
      _c(
        "el-form",
        {
          ref: "modifyPwdForm",
          staticClass: "modify-pwd-form",
          attrs: { "auto-complete": "on", "label-position": "left" }
        },
        [
          _c(
            "el-form-item",
            { staticClass: "login-form-item", attrs: { prop: "phone" } },
            [
              _c("span", { staticClass: "svg-container" }, [
                _c("i", { staticClass: "iconfont iconuser1" })
              ]),
              _c("el-input", {
                attrs: {
                  placeholder: "手机号",
                  type: "text",
                  tabindex: "1",
                  "auto-complete": "on"
                },
                model: {
                  value: _vm.modifyPwdForm.phone,
                  callback: function($$v) {
                    _vm.$set(_vm.modifyPwdForm, "phone", $$v)
                  },
                  expression: "modifyPwdForm.phone"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-form-item",
                { staticClass: "login-form-item", attrs: { prop: "smsCode" } },
                [
                  _c("span", { staticClass: "svg-container" }, [
                    _c("i", { staticClass: "iconfont iconyanzhengma" })
                  ]),
                  _c("el-input", {
                    attrs: {
                      placeholder: "验证码",
                      type: "text",
                      tabindex: "1",
                      "auto-complete": "on"
                    },
                    model: {
                      value: _vm.modifyPwdForm.smsCode,
                      callback: function($$v) {
                        _vm.$set(_vm.modifyPwdForm, "smsCode", $$v)
                      },
                      expression: "modifyPwdForm.smsCode"
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text", disabled: _vm.duration > 0 },
                      on: { click: _vm.getSmsCode }
                    },
                    [_vm._v(_vm._s(_vm.text))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "login-form-item", attrs: { prop: "password" } },
            [
              _c("span", { staticClass: "svg-container" }, [
                _c("i", { staticClass: "iconfont iconpassword" })
              ]),
              _c("el-input", {
                attrs: {
                  placeholder: "密码",
                  type: "text",
                  tabindex: "1",
                  "auto-complete": "on"
                },
                model: {
                  value: _vm.modifyPwdForm.password,
                  callback: function($$v) {
                    _vm.$set(_vm.modifyPwdForm, "password", $$v)
                  },
                  expression: "modifyPwdForm.password"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  staticClass: "login-btn",
                  staticStyle: { width: "100%" },
                  attrs: { loading: _vm.loading, type: "primary" },
                  on: { click: _vm.confirm }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }